import type { CompanionComponent } from "@m8t-stack/platform-release";
import { fetchManifest, CHANNEL_LATEST_URL, type ManifestSource } from "./release-channel.js";

export interface CompanionRelease {
  readonly component: CompanionComponent;
  /** How urgent the release that carries it said it was. */
  readonly severity: "critical" | "recommended" | "optional";
  readonly platformVersion: string;
}

/**
 * What the release channel currently offers for the desktop companions, or
 * null when it offers none.
 *
 * Null is the ordinary answer, not a fault: every manifest cut before the
 * companions were released carries no companion at all, and a caller that
 * treats that as a failure would tell a founder to repair something that was
 * never published.
 */
export async function readCompanionRelease(
  source: ManifestSource = { url: CHANNEL_LATEST_URL },
  deps: Parameters<typeof fetchManifest>[1] = {},
): Promise<CompanionRelease | null> {
  const manifest = await fetchManifest(source, deps);
  const component = manifest.components.companion;
  if (!component) return null;
  return {
    component,
    severity: manifest.platform.severity,
    platformVersion: manifest.platform.version,
  };
}
